export const PLACEMENT_STATUS_DEFAULT_TTL_MS = 60_000;
export const PLACEMENT_STATUS_MAX_EVENTS = 20;
